import React, { useEffect, useMemo, useRef, useState } from "react";
import { MainWrapper } from "app/pages/company/component/MainWrapper";
import { TopBar } from "app/pages/company/component/TopBar";
import { FormattedMessage } from "react-intl";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { useGet } from "app/pages/company/Hooks/Api/useGet";
import { getStripeTransactions } from "sr/utils/api/strip/getStripeTransactions";
import { Pagination } from "app/pages/component/Pagination";
import { TransactionsTable } from "app/pages/component/TransactionsTable";

export const MyTransactions = () => {
  const { getData, data, loader, pageination }: any = useGet();
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const getDataRef = useRef(getData);

  useEffect(() => {
    getDataRef.current = getData;
  }, [getData]);

  useEffect(() => {
    const fetchTransactions = async () => {
      const queryParams = new URLSearchParams();
      queryParams.append("limit", String(limit));
      queryParams.append("page", String(page));
      await getDataRef.current(() =>
        getStripeTransactions(queryParams.toString()),
      );
    };
    fetchTransactions();
  }, [limit, page]);

  const rows = useMemo(() => (Array.isArray(data) ? data : []), [data]);
  const totalPage = useMemo(() => {
    const total = Number(pageination?.total || 0);
    const pageSize = Number(pageination?.pageSize || limit);
    if (!total || !pageSize) return 1;
    return Math.max(1, Math.ceil(total / pageSize));
  }, [pageination?.total, pageination?.pageSize, limit]);

  return (
    <MainWrapper>
      <div className="py-3">
        <TopBar
          title={
            <span className="inline-flex items-center gap-2">
              <FormattedMessage
                id="COMPANY.TRANSACTIONS.TITLE"
                defaultMessage="My Transactions"
              />
              {pageination?.total !== undefined ? (
                <span className="text-neutral-500">
                  ({Number(pageination?.total || 0)})
                </span>
              ) : null}
            </span>
          }
          showTitleDivider={false}
          postButton={<></>}
          className="px-10"
        />
        <ContentWithSpinner loader={loader} height="h-screen">
          <div className="px-4 md:px-10">
            <div className="bg-white rounded-lg p-5 border border-neutral-200">
              <TransactionsTable
                rows={rows}
                mode="payer"
                workorderLinkBase="/work-order-details"
                titleLabel="Work Order"
              />

              {totalPage > 1 ? (
                <Pagination page={page} totalPage={totalPage} setPage={setPage} />
              ) : null}
            </div>
          </div>
        </ContentWithSpinner>
      </div>
    </MainWrapper>
  );
};
